/**
 * Copyright 2025 Design Barn Inc.
 */

import React from 'react';

export default function GmailIcon(): React.ReactElement {
  return (
    <div className="flex items-center justify-center rounded-[8px] bg-white p-[2px]">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M23.06 12.75C23.06 11.97 22.99 11.22 22.86 10.5H12.5V14.755H18.42C18.165 16.13 17.39 17.295 16.225 18.075V20.835H19.78C21.86 18.92 23.06 16.1 23.06 12.75Z"
          fill="#4285F4"
        />
        <path
          d="M12.5 23.4998C15.47 23.4998 17.96 22.5148 19.78 20.8348L16.225 18.0748C15.24 18.7348 13.98 19.1248 12.5 19.1248C9.63504 19.1248 7.21004 17.1898 6.34504 14.5898H2.67004V17.4398C4.48004 21.0348 8.20004 23.4998 12.5 23.4998Z"
          fill="#34A853"
        />
        <path
          d="M6.345 14.5905C6.125 13.9305 6 13.2255 6 12.5005C6 11.7755 6.125 11.0705 6.345 10.4105V7.56055H2.67C1.9 9.09341 1.49932 10.7852 1.5 12.5005C1.5 14.2755 1.925 15.9555 2.67 17.4405L6.345 14.5905Z"
          fill="#FBBC05"
        />
        <path
          d="M12.5 5.875C14.115 5.875 15.565 6.43 16.705 7.52L19.86 4.365C17.955 2.59 15.465 1.5 12.5 1.5C8.20004 1.5 4.48004 3.965 2.67004 7.56L6.34504 10.41C7.21004 7.81 9.63504 5.875 12.5 5.875Z"
          fill="#EA4335"
        />
      </svg>
    </div>
  );
}
